import { useCallback } from 'react';
import { LEGACY_DRAFT_STORAGE_KEY, SESSION_ID_STORAGE_KEY } from '../utils/constants';

export function useWizardSessionStorage() {
  const getSessionId = useCallback(() => {
    try {
      return localStorage.getItem(SESSION_ID_STORAGE_KEY);
    } catch {
      return null;
    }
  }, []);

  const setSessionId = useCallback((sessionId) => {
    try {
      localStorage.setItem(SESSION_ID_STORAGE_KEY, sessionId);
    } catch (e) {
      console.error('Failed to save setup wizard session id', e);
    }
  }, []);

  const clearSessionId = useCallback(() => {
    try {
      localStorage.removeItem(SESSION_ID_STORAGE_KEY);
    } catch (e) {
      console.error('Failed to clear setup wizard session id', e);
    }
  }, []);

  const clearLegacyDraft = useCallback(() => {
    try {
      localStorage.removeItem(LEGACY_DRAFT_STORAGE_KEY);
    } catch {
      /* ignore */
    }
  }, []);

  return { getSessionId, setSessionId, clearSessionId, clearLegacyDraft };
}
